import { useEventListener, useResizeObserver } from '@vueuse/core';
import { computed, ref, type Ref } from 'vue';

export function useLastFixedColumnShadow(
  tableContainerRef: Ref<HTMLElement | null>,
): { showLastFixedColumnShadow: Ref<boolean> } {
  const showLastFixedColumnShadow = ref(false);

  const scrollElement = computed<HTMLElement | null>(
    () =>
      tableContainerRef.value?.querySelector('.internal-data-table__main') ??
      null,
  );
  const tableElement = computed<HTMLElement | null>(
    () => scrollElement.value?.querySelector('table') ?? null,
  );

  const updateShadowVisibility = () => {
    const element = scrollElement.value;
    showLastFixedColumnShadow.value =
      !!element &&
      element.scrollWidth - element.clientWidth - element.scrollLeft > 1;
  };

  useEventListener(scrollElement, 'scroll', updateShadowVisibility, {
    passive: true,
  });
  useResizeObserver(scrollElement, updateShadowVisibility);
  useResizeObserver(tableElement, updateShadowVisibility);

  return { showLastFixedColumnShadow };
}
